"use strict";
import { customSeriesDefaultOptions } from "lightweight-charts";
export const defaultOptions = {
  ...customSeriesDefaultOptions,
  colors: [],
  gradients: void 0,
  lineWidth: 2
};
